import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import styled from 'styled-components'

export const StyledExtendMenuItem = styled(Flex)`
  height: 44px;
  cursor: pointer;
  align-items: center;
  padding-right: 2px;
  border-radius: ${({ theme }) => theme.radii.tiny} !important;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;

  ${({ theme: { mediaQueries } }) => mediaQueries.sm} {
    max-width: 204px;
  }

  &:after {
    content: '';
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    transition: ease ${({ theme }) => theme.transitions.fast};
    background: linear-gradient(270deg, rgba(255, 255, 255, 0.4) -2.78%, rgba(255, 255, 255, 0) 87.04%);
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`

export const StyledTitle = styled(Text)`
  font-size: 12px;
  line-height: 1.2em;
`

export const StyledText = styled(Text)`
  position: relative;
  z-index: 11;
`
